import {Directive, ElementRef, OnInit, Renderer2, HostListener, AfterViewInit} from '@angular/core';
import {NgControl} from '@angular/forms';

import {TerraNumberPipe} from '../pipes/TerraNumber.pipe';

// NOTICE: https://blog.ngconsultant.io/custom-input-formatting-with-simple-directives-for-angular-2-ec792082976
// the article forgot to mention: it's also required registration as a provider (did it in the shared module)

@Directive({selector: '[terraFormattedNumber]'})
export class MyCurrencyFormatterDirective implements AfterViewInit {
  private el: HTMLInputElement;
  private isInFocus: boolean;

  constructor(private elementRef: ElementRef, private control: NgControl, private numberPipe: TerraNumberPipe, private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    this.el = this.elementRef.nativeElement;
    this.el.value = this.numberPipe.transform(this.el.value);

    this.renderer.listen(this.el, 'focus', event => {
      const parsedNumber = this.numberPipe.parse(this.el.value);
      if (parsedNumber === null) {
        this.el.value = null;
      } else {
        this.el.value = parsedNumber.toString();
      }
      this.control.control.patchValue(parsedNumber);
      this.isInFocus = true;
    });

    this.renderer.listen(this.el, 'blur', event => {
      // Set the form control value as the unformatted number,
      // and the value visible in the input as the formatted value
      this.control.valueAccessor.writeValue(this.numberPipe.parse(this.el.value));
      this.el.value = this.numberPipe.transform(this.el.value);
      this.control.control.patchValue(this.el.value);
      this.isInFocus = true;
    });
  }

  @HostListener('ngModelChange', ['$event'])
  valueChange(event) {
    if (!this.isInFocus) {
      this.el.value = this.numberPipe.transform(this.el.value);
    }
  }
}
